import * as Blockly from 'blockly/core';

export class FieldStyledLabel extends Blockly.FieldLabel {
    private fontSize_: number | null;
    private fontWeight_: string;
    private minWidth_: number;
    private numberStyle_: boolean;

    constructor(
        text: string,
        options?: {
            fontSize?: number;
            fontWeight?: string;
            minWidth?: number;
            numberStyle?: boolean;
        },
    ) {
        super(text);
        this.fontSize_ = options?.fontSize ?? null;
        this.fontWeight_ = options?.fontWeight ?? 'normal';
        this.minWidth_ = options?.minWidth ?? 0;
        this.numberStyle_ = options?.numberStyle ?? false;
    }

    override initView(): void {
        super.initView();
        if (this.numberStyle_ && this.fontSize_ === null) {
            (this as any).textElement_?.classList.add('blocklyNumberFieldText');
        }
    }

    override render_(): void {
        super.render_();
        if (this.textElement_) {
            if (!this.numberStyle_) {
                this.textElement_.style.fontWeight = this.fontWeight_;
            }
            if (this.numberStyle_ && this.fontSize_ !== null) {
                this.textElement_.style.fontFamily = 'Cantarell, sans-serif';
                this.textElement_.style.fontWeight = '600';
                this.textElement_.style.fontSize = `${this.fontSize_}pt`;
            } else if (!this.numberStyle_ && this.fontSize_ !== null) {
                this.textElement_.style.fontSize = `${this.fontSize_}pt`;
            }
        }

        const textWidth = this.textElement_?.getComputedTextLength() || this.size_.width;
        let finalWidth = textWidth;

        if (this.minWidth_ > 0 && finalWidth < this.minWidth_) {
            finalWidth = this.minWidth_;
        }

        if (finalWidth > 0) {
            this.size_ = new Blockly.utils.Size(finalWidth, this.size_.height);

            if (this.minWidth_ > 0 && this.textElement_) {
                this.textElement_.setAttribute('text-anchor', 'middle');
                this.textElement_.setAttribute('x', String(finalWidth / 2));
            }
        }
    }

    override setValue(newValue: string): void {
        (this as any).value_ = newValue;
        if (this.textElement_) {
            this.textElement_.textContent = newValue;
            this.render_();
        }
    }
}
